export type SetWindowLocationHrefImplementation = (value: string) => void;

// Kept on window rather than in module state: Granite remotes each bundle their
// own copy of this module, and an override installed by the host has to reach
// all of them.
const IMPLEMENTATION_KEY = Symbol.for(
  'hs-browser-apis.setWindowLocationHrefImplementation'
);

type WindowWithImplementation = Window & {
  [IMPLEMENTATION_KEY]?: SetWindowLocationHrefImplementation;
};

const defaultImplementation: SetWindowLocationHrefImplementation = (value) => {
  window.location.href = value;
};

export function getWindowLocationHrefImplementation(): SetWindowLocationHrefImplementation {
  return (
    (window as WindowWithImplementation)[IMPLEMENTATION_KEY] ??
    defaultImplementation
  );
}

/**
 * Replaces how `setWindowLocationHref` navigates for every consumer on the
 * page. Only quartz-core is expected to manage this, so there is a single
 * override: setting it again replaces it, and the returned function restores
 * the default behavior.
 */
export function setWindowLocationHrefImplementation(
  override: SetWindowLocationHrefImplementation
): () => void {
  (window as WindowWithImplementation)[IMPLEMENTATION_KEY] = override;
  return () => {
    delete (window as WindowWithImplementation)[IMPLEMENTATION_KEY];
  };
}
